import React from 'react';
import CollapsibleCard from 'components/UI/CollapsibleCard';
import ReservationNumbersSummary from './Loadable';

function Card(props)
{
    return (
        <>
            { /* eslint-disable-next-line react/jsx-props-no-spreading */ }
            <CollapsibleCard title="Booking Summary" defaultState storeId="booking_numbers_summary" {...props}>
                { /* eslint-disable-next-line react/jsx-props-no-spreading */ }
                <ReservationNumbersSummary {...props} />
            </CollapsibleCard>
        </>
    );
}

export default Card;
